import { useMemo } from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
const FooterSummary = ({
  newProductList,
  amazon_savings_amount,
  amazon_savings_percent,
  handleAddToCart,
  handleBackToMessages,
  shopperooRender,
  selectedStore,
  savingsAmount,
  savingsPercent,
  storeDetails
}) => {
  const { totalItems, totalPrice } = useMemo(() => {
    return newProductList.reduce(
      (acc, { quantity, price }) => {
        acc.totalItems += quantity;
        acc.totalPrice += quantity * price;
        return acc;
      },
      { totalItems: 0, totalPrice: 0 }
    );
  }, [newProductList]);
  const formattedTotalPrice = totalPrice.toFixed(2);
  console.log("selectedStore",selectedStore)
  return (
    <div className="w-full bg-white border-t border-gray-200 px-4 py-3">
      <div
        className="
            flex flex-col gap-3
            sm:flex-row sm:items-center sm:justify-between
          "
      >
        {/* Summary Text */}
        <div
          className="
    text-sm text-gray-900 font-medium
    leading-[1.2rem]
    min-h-[2.4rem]
  "
        >
          {/* Line 1 */}
          <p className="truncate">
            <span>🛒</span>
            <span className="font-bold"> ${formattedTotalPrice}</span>
            <span className="mx-1">·</span>
            <span>{totalItems} items</span>
          </p>

          {/* Line 2 */}
          {(savingsAmount > 0 && savingsPercent >= 20) && (
            <p className="text-black truncate">
              Saving ${savingsAmount} vs {selectedStore || 'Amazon’s'} first picks
            </p>
          )}
        </div>

        {/* CTA Button */}
        {storeDetails?.length > 0 &&
        <button
          onClick={handleAddToCart}
          className="
              w-full sm:w-auto
              bg-black text-white
              p-[16px]
              rounded-[50px]
              text-sm font-semibold
              whitespace-nowrap
            "
        >
          Single-click Add to {selectedStore || 'Amazon'} Cart{" "}
          <ArrowRightOutlined sx={{ fontSize: "1.0rem" }} />
        </button>
        }

        {!shopperooRender && (
          <button
            onClick={handleBackToMessages}
            className="
                w-full sm:w-auto
                bg-black text-white
               px-4 py-2
              rounded-[50px]
                text-sm font-semibold
                whitespace-nowrap
              "
          >
            ← Back To Roo
          </button>
        )}
      </div>
    </div>
  );
};

export default FooterSummary;
